import MovieCard from "@/components/feature/MovieCard";
import type { Movie } from "@/types/movie";

interface MovieGridProps {
  movies: Movie[];
  emptyText?: string;
  onReset?: () => void;
  isFavorite?: (id: number) => boolean;
  onToggleFavorite?: (id: number) => void;
}

export default function MovieGrid({
  movies,
  emptyText = "暂无相关影视资源",
  onReset,
  isFavorite,
  onToggleFavorite,
}: MovieGridProps) {
  if (!movies.length) {
    return (
      <div className="flex flex-col items-center justify-center rounded-lg border border-background-200 bg-background-100 px-6 py-16 text-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-foreground-500">
          <i className="ri-film-line text-2xl" />
        </span>
        <p className="mt-4 text-sm text-foreground-700">{emptyText}</p>
        {onReset && (
          <button
            type="button"
            onClick={onReset}
            className="mt-5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            重置筛选条件
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-x-5 gap-y-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {movies.map((movie) => (
        <MovieCard
          key={movie.id}
          movie={movie}
          isFavorite={isFavorite ? isFavorite(movie.id) : false}
          onToggleFavorite={onToggleFavorite}
        />
      ))}
    </div>
  );
}